"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var React = _interopRequireWildcard(require("react"));

var _createSvgIcon = _interopRequireDefault(require("../utils/createSvgIcon"));

/* eslint-disable react/prop-types */

/* eslint-disable prettier/prettier */
var _default = (0, _createSvgIcon.default)( /*#__PURE__*/React.createElement("g", {
  fill: "none"
}, /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M16.8201 3.69001L21.8201 7.61C21.9363 7.70543 22.0045 7.84729 22.0065 7.99768C22.0084 8.14807 21.9439 8.29164 21.8301 8.39001L16.8301 12.31C16.682 12.4401 16.4712 12.4711 16.2919 12.389C16.1127 12.3069 15.9984 12.1272 16.0001 11.93V10H3.00008C2.4478 10 2.00008 9.55229 2.00008 9.00001V7.00001C2.00008 6.44772 2.4478 6.00001 3.00008 6.00001H15.9901V4.07C15.9884 3.87285 16.1027 3.69308 16.2819 3.611C16.4612 3.52893 16.672 3.55987 16.8201 3.69001ZM7.18008 11.69L2.18008 15.61C2.06383 15.7054 1.99562 15.8473 1.99369 15.9977C1.99177 16.1481 2.05632 16.2916 2.17008 16.39L7.17008 20.31C7.3182 20.4401 7.52897 20.4711 7.70824 20.389C7.88751 20.3069 8.00181 20.1272 8.00008 19.93V18H21.0001C21.5524 18 22.0001 17.5523 22.0001 17V15C22.0001 14.4477 21.5524 14 21.0001 14H8.01008V12.07C8.01181 11.8728 7.89751 11.6931 7.71824 11.611C7.53897 11.5289 7.3282 11.5599 7.18008 11.69Z",
  fill: "currentColor"
})), 'Exchange');

exports.default = _default;